import { Injectable } from '@angular/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SCE_MODULES } from '../constants/sce_modules';

export type SceModulesTypeof = typeof SCE_MODULES[keyof typeof SCE_MODULES];

export type TabType = {
    name: string;
    value: SceModulesTypeof;
    hasAccess: boolean;
};

@Injectable({
    providedIn: 'root',
})
export class SourceCodeExcludesService {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private translateService: TranslateService,
    ) {}

    getTabs (): TabType[] {
        return [
            {
                name: this.translateService.getString('Accessibility'),
                value: SCE_MODULES.accessibility,
                hasAccess: this.activeFeatureService.isFeatureActive(
                    'admin_accessibility',
                ),
            },
            {
                name: this.translateService.getString('Misspellings'),
                value: SCE_MODULES.misspelling,
                hasAccess:
        this.activeFeatureService.isFeatureActive(
            'admin_source_code_excludes',
        ) && this.activeFeatureService.isFeatureActive('qa_spellcheck'),
            },
            {
                name: this.translateService.getString('Readability'),
                value: SCE_MODULES.readability,
                hasAccess:
          this.activeFeatureService.isFeatureActive(
              'admin_source_code_excludes',
          ) && this.activeFeatureService.isFeatureActive('admin_readability'),
            },
            {
                name: this.translateService.getString('Language Validation'),
                value: SCE_MODULES.language_match,
                hasAccess:
          this.activeFeatureService.isFeatureActive(
              'admin_source_code_excludes',
          ) && this.activeFeatureService.isFeatureActive('language_match'),
            },
        ].filter((tab) => tab.hasAccess);
    }

    getDefaultTab () {
        const tabs = this.getTabs();
        return tabs[0]?.value;
    }

    isAccessibility (module: SceModulesTypeof) {
        return SCE_MODULES.accessibility === module;
    }
}
